import { Pipe, PipeTransform } from '@angular/core';

/**
 * Narrows a select's options to the ones whose label contains the typed text,
 * for dropdowns that render their own search box (e.g. the tidy-table inline selects).
 */
@Pipe({
  name: 'filterSelectItems',
  standalone: false,
})
export class FilterSelectItemsPipe implements PipeTransform {
  transform<T extends { viewValue?: string }>(items: T[] | null | undefined, query: string | null | undefined): T[] {
    const list = items ?? [];
    const needle = (query ?? '').trim().toLowerCase();
    if (!needle) { return list; }
    return list.filter(item => (item.viewValue ?? '').toLowerCase().includes(needle));
  }
}
